import { ContentViewStyle } from '@levelapp/softfabric';
export default class TableViewStyle extends ContentViewStyle {
    constructor() {
        super(...arguments);
        this.thRow = {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            borderBottomWidth: 1,
            paddingTop: 12,
            paddingBottom: 12,
            borderColor: '#e0e0e0',
        };
        this.tdRow = {
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'space-between',
            borderBottomWidth: 1,
            paddingTop: 12,
            paddingBottom: 12,
            borderColor: '#e0e0e0',
        };
        this.thText = {
            color: 'black',
            fontWeight: 'bold',
            fontSize: 15,
        };
        this.tdText = {
            color: '#3f3f3f',
            fontWeight: '300',
            flexWrap: 'wrap',
        };
        this.showImage = {
            opacity: 1,
            marginLeft: 5,
            alignSelf: 'center',
            height: 12,
            width: 12
        };
        this.notShowingImage = {
            opacity: 0,
        };
        this.containerResearch = {
            marginTop: 15,
            flexDirection: 'row',
            flex: 1,
            justifyContent: 'flex-end',
        };
        this.nothingToDisplay = {
            flex: 1,
            marginTop: 15,
            alignItems: 'center',
        };
    }
}
